







































































































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton, LongTextWings} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {BlacklistContactItem} from "@/store/blacklists/types";
import ImportContacts from "@/components/BlackLists/ImportContacts.vue";
import BlackListContactsFilter from "@/components/BlackLists/BlackListContactsFilter.vue";
import BlackListContactActions from "@/components/BlackLists/BlackListContactActions.vue";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';

@Component({components: {BlackListContactsFilter, BlackListContactActions, ImportContacts, LongTextWings, ScrollButton}})
export default class BlackListContacts extends BaseItemsPage<BlacklistContactItem>{
  @Getter("blacklistContacts") blacklistContactsResponse: any;
  @Getter("blacklistItem") blacklistItem: any;
  @Action("getBlackListContacts") actionGetBlacklistContacts: any;
  @Action("exportBlackListContacts") actionExport: any;
  @Action("deleteBlackListContacts") actionDelete: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}
  private is_show_filter = false;
  private is_show_import = false;
  private is_show_actions = false;
  private recipientIds:(number|undefined)[] = [];
  currentSort = "id";
  currentSortOrder = "desc";
  tableFields = ['id', 'msisdn', 'email', 'comment',];

  getData(): any {
    return this.blacklistContactsResponse;
  }

  back(): void{
    this.$router.push('/black_list/group');
  }

  async exportContacts() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Export",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({blackListId: this.blacklistItem?.name})
      }
      await this.actionExport(this.$route.params.id)
      await this.actionLog(this.logObject)
    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  onSelect(items:BlacklistContactItem[]):void {
    this.recipientIds = items.filter(i => i.id).map(i => i.id)
  }

  onRefresh() {
    // @ts-ignore
    this.$refs.filter.filtered()
  }
}
